import { render, staticRenderFns } from "./add-pharmacy.vue?vue&type=template&id=4ef450f6&"
import script from "./add-pharmacy.vue?vue&type=script&lang=js&"
export * from "./add-pharmacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports